import React from 'react'
import { connect } from 'react-redux'
import Title from './Title'
import Description from './Description'
import Fields from './Fields'
import SubscribeButton from './SubscribeButton'
import CloseModal from './CloseModal'
import { withStyles } from '@material-ui/core'
import styles from 'components/AddOrEditFormPage/Form/styles'
import classNames from 'classnames'
import Logo from './Logo'
import Sections from './Sections'
import AddSectionButton from '../AddSectionButton'
import PageButtons from './PageButtons'
import './iframe.css'

export default connect(
  state => ({
    font: state.signupForm.addOrEdit.values.font.value,
    textColor: state.signupForm.addOrEdit.values.textColor.value,
    backgroundColor: state.signupForm.addOrEdit.values.backgroundColor.value,
    formViewSelected: state.signupForm.addOrEdit.formViewSelected,
    embedType: state.signupForm.addOrEdit.values.embedType.value,
    formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
  }),
  null,
)(
  withStyles(styles)(
    ({
      font,
      textColor,
      backgroundColor,
      formViewSelected,
      classes,
      embedType,
      formTypeSelected,
    }) => (
      <>
        <div
          id="PreviewViewFormView"
          style={{
            background:
              embedType === 'popover' && formTypeSelected === 'signup'
                ? '#000000ba'
                : 'none',
            paddingLeft:
              embedType === 'popover' && formTypeSelected === 'signup' ? 20 : 0,
            paddingRight:
              embedType === 'popover' && formTypeSelected === 'signup' ? 20 : 0,
          }}
          className={
            formTypeSelected === 'custom'
              ? classes.previewCustom
              : classNames(
                  classes.preview,
                  classes[formViewSelected],
                  `preview-${formViewSelected}`,
                )
          }
        >
          <div
            className={`${
              formTypeSelected === 'custom' ? 'addOrEditModalCustom ' : ''
            }addOrEditFormPageModal`}
          >
            <div
              style={{
                backgroundColor,
                fontFamily: font,
                color: textColor,
                borderRadius: '8px',
                margin:
                  embedType === 'popover' && formTypeSelected === 'signup'
                    ? 'auto'
                    : 0,
                padding: formTypeSelected === 'custom' ? 0 : '40px',
                // maxWidth: '840px',
                position: 'relative',
                boxShadow:
                  embedType === 'popover' && formTypeSelected === 'signup'
                    ? '0 0 10px #000'
                    : 'initial',
                overflowWrap: 'break-word',
              }}
            >
              {formTypeSelected === 'custom' ? (
                <div style={{ padding: '20px 20px 0' }}>
                  <Logo />
                  <Title />
                  <Description />
                </div>
              ) : (
                <>
                  <Logo />
                  <Title />
                  <Description />
                </>
              )}
              {formTypeSelected === 'custom' && <Sections />}
              {formTypeSelected === 'signup' && <Fields />}
              <SubscribeButton />
              <div
                style={{
                  padding: '0 20px 20px',
                  textAlign: 'center',
                  position: 'relative',
                }}
              >
                <PageButtons />
              </div>
              <CloseModal />
            </div>
            {formTypeSelected === 'custom' && <AddSectionButton />}
          </div>
        </div>
      </>
    ),
  ),
)
